import { WebPlugin } from '@capacitor/core';
export class SafeAreaWeb extends WebPlugin {
    async setSystemBarsStyle() {
        this.unavailable('not available for web');
    }
    async showSystemBars() {
        this.unavailable('not available for web');
    }
    async hideSystemBars() {
        this.unavailable('not available for web');
    }
}
//# sourceMappingURL=web.js.map